import React from 'react'
import { IonButton, IonButtons, IonFooter, IonPage, IonToolbar, useIonViewWillLeave } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import PCRHeader from '../../../../components/pcrHeader/PCRHeader.component'
import HeaderNav from '../../../../components/headerNav/HeaderNav.component'
import { TabConstants } from '../../../../components/tabs/Tabs.constants'
import {
  saveVitals,
  setWithdrawalScale,
  setWithdrawalScaleType,
  setWithdrawalScaleTotal,
  setWithdrawalScaleTotalPNNV,
  setWithdrawalScaleTotalPNNVEnabled,
  setWithdrawalScaleTypeCleared,
  checkQuickActionsRedirect,
} from '../../store/vitals.actions'
import { IRootState } from '../../../../store'
import WithdrawalScaleContent from '../content/WithdrawalScale.content'
import { setScrollTargetID } from '../../../../components/scrollToTopButton/store/scrollToTop.actions'

const WithdrawalScalePage: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const {
    withdrawalScaleCriteria,
    withdrawalScaleTotal,
    withdrawalScaleTotalPNNV,
    withdrawalScaleType,
    __isWithdrawalScaleTotalPNNVEnabled,
  } = useSelector((state: IRootState) => state.vitals)

  const hasWithdrawalScaleData =
    !!withdrawalScaleType ||
    !!withdrawalScaleCriteria?.length ||
    !!withdrawalScaleTotal ||
    !!withdrawalScaleTotalPNNV ||
    __isWithdrawalScaleTotalPNNVEnabled

  const navigateBackToVitals = () => {
    history.replace(TabConstants.VITALS_TAB)
  }

  useIonViewWillLeave(() => {
    if (history.location.pathname !== TabConstants.VITALS_TAB) {
      dispatch(checkQuickActionsRedirect())
    } else {
      dispatch(setScrollTargetID('withdrawalScaleButton'))
    }
  })

  const handleClear = () => {
    dispatch(setWithdrawalScaleType(null))
    dispatch(setWithdrawalScaleTypeCleared(true))
    dispatch(setWithdrawalScale([]))
    dispatch(setWithdrawalScaleTotal(null))
    dispatch(setWithdrawalScaleTotalPNNV(null))
    dispatch(setWithdrawalScaleTotalPNNVEnabled(false))
    dispatch(saveVitals())
  }

  return (
    <IonPage id='WithdrawalScalePage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={navigateBackToVitals}
        prevLabel={t('common.buttons.Back')}
        title={t('vitals.withdrawalScale.title')}
        isBackButton={true}
      />
      <WithdrawalScaleContent />
      <IonFooter>
        <IonToolbar color='light' className='p-10'>
          <IonButtons className='btn-grps'>
            <IonButton
              className='btn btn-tablet'
              color='danger'
              fill='outline'
              expand='block'
              disabled={!hasWithdrawalScaleData}
              onClick={handleClear}>
              {t('common.buttons.Clear')}
            </IonButton>
            <IonButton
              className='btn btn-tablet btn-primary'
              expand='block'
              disabled={!hasWithdrawalScaleData}
              onClick={() => {
                dispatch(saveVitals())
                navigateBackToVitals()
              }}>
              {t('common.buttons.Save')}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  )
}

export default WithdrawalScalePage
